import { useState, useCallback } from 'react';
import { useTheme } from '@mui/material/styles';
import { LABEL_CONFIG, MODE } from './config';

export { MODE };

export const useTextInputHot = (props) => {
  const theme = useTheme();
  const { value, placeholder, error, onFocus, onBlur, mode: inputMode = MODE.OUTLINED } = props;
  const [isFocused, setIsFocused] = useState(false);

  const hasValue = !!value && String(value).length > 0;
  const shouldFloat = isFocused || hasValue;

  const modeConfig = LABEL_CONFIG[inputMode] || LABEL_CONFIG[MODE.OUTLINED];
  const defaultConfig = modeConfig.default;
  const focusedConfig = modeConfig.focused;

  const labelTop = shouldFloat ? focusedConfig.top : defaultConfig.top;
  const labelFontSize = shouldFloat ? focusedConfig.fontSize : defaultConfig.fontSize;

  const labelColor = error
    ? theme.palette.error.main
    : isFocused
    ? theme.palette.primary.main
    : theme.palette.text.subtle;

  const placeholderRight = shouldFloat ? focusedConfig.placeholderRight : defaultConfig.placeholderRight;

  const shouldShowPlaceholder = !!placeholder && (
    shouldFloat ? focusedConfig.shouldShow : defaultConfig.shouldShow
  );

  const handleFocus = useCallback((e) => {
    setIsFocused(true);
    onFocus?.(e);
  }, [onFocus]);

  const handleBlur = useCallback((e) => {
    setIsFocused(false);
    onBlur?.(e);
  }, [onBlur]);

  const labelBackgroundColor = inputMode === MODE.OUTLINED && shouldFloat
    ? theme.palette.background.paper
    : 'transparent';

  return {
    isFocused,
    labelTop,
    labelFontSize,
    labelColor,
    labelBackgroundColor,
    placeholderRight,
    handleFocus,
    handleBlur,
    shouldShowPlaceholder,
    shouldFloat,
  };
};
